<template>
	<main>
		<transition name="fade">
			<router-view/>
		</transition>
		<loader
			:loading="$store.state.contentLoading"
		></loader>
	</main>
</template>

<script>
// Components
import Loader from '@/components/utils/Loader.vue';

export default {
	components: {
		Loader
	}
};
</script>
